import React from 'react';
import { motion } from 'framer-motion';

const pageVariants = {
    initial: { opacity: 0, y: -20 },
    animate: { opacity: 1, y: 0 },
    exit: { opacity: 0, y: 20 },
  };


const About = () => {
  return (
    <motion.div initial="initial"
    animate="animate"
    exit="exit"
    variants={pageVariants}>

<div className="about-page">
      {/* Section 1 */}
      <h2 className="collection-titletwo">À propos de nous</h2>
          <p class="about-subtitle">
             Découvrez notre histoire, notre passion et notre engagement à vous offrir le meilleur.
          </p>
      <section className="container about-sectiontwo">
        <div className="about-contenttwo">
          <div className="about-imagestwo">
            <img src="/images/burgundy.jpg" alt="Decorative Cushion 1" />
          </div>
          <div className="about-texttwo">
            <h2>Notre Inspiration</h2>
            <p>
            Chez Cushions By Asma, nous puisons notre inspiration dans une parfaite harmonie entre designs intemporels et tendances contemporaines pour créer des coussins décoratifs élégants. Nous croyons que la décoration intérieure doit allier tradition et modernité, offrant ainsi des pièces à la fois classiques et raffinées. Chaque coussin est conçu pour sublimer votre espace de vie, apportant une touche de sophistication et de charme, tout en préservant une atmosphère chaleureuse et accueillante.
            </p>
            <p>
              Nous nous inspirons des styles les plus emblématiques de l’histoire du design, tout en restant attentifs aux évolutions modernes de la décoration intérieure. Chaque motif, chaque texture et chaque couleur sont soigneusement sélectionnés pour évoquer une esthétique à la fois intemporelle et contemporaine. Nous intégrons des éléments inspirés des grandes tendances du design d’intérieur, qu’il s’agisse de minimalisme épuré, de touches bohèmes chaleureuses ou d’influences classiques revisitées.
            </p>
            <p>
            Au-delà du style, nous accordons une importance particulière au choix des matériaux et aux finitions, car nous croyons qu’un coussin ne doit pas seulement être beau, mais aussi agréable au toucher et durable. C’est pourquoi nous utilisons des tissus de haute qualité, sélectionnés pour leur douceur, leur résistance et leur impact esthétique. Nos créations sont le fruit d’un travail minutieux, où chaque détail est pensé pour apporter une sensation de luxe et de bien-être à votre intérieur.
            </p>
          </div>
        </div>
      </section>

      {/* Section 2 */}
      <section className="about-sectiontwo">
        <div className="about-contenttwo">
          <div className="about-imagestwo">
            <img src="/images/orangecushions.jpg" alt="Decorative Cushion 2" />
          </div>
          <div className="about-texttwo">
            <h2>Notre Savoir-Faire</h2>
            <p>
              Chaque coussin que nous confectionnons est le fruit d'un artisanat minutieux, de matériaux haut de gamme et d'une attention particulière aux détails. Nous sélectionnons des tissus de qualité supérieure pour offrir un toucher luxueux et assurer une durabilité optimale. Du velours somptueux aux broderies délicates, nos créations capturent à la fois élégance et confort. Chaque pièce est soumise à un contrôle rigoureux de qualité, garantissant non seulement une esthétique exquise, mais aussi un soutien et une longévité qui répondent aux attentes des accessoires haut de gamme.
            </p>
          </div>
        </div>
      </section>

      {/* Section 3 */}
      <section className="about-sectiontwo">
        <div className="about-contenttwo">
          <div className="about-imagestwo">
            <img src="/images/download (4).jpg" alt="Decorative Cushion 3" />
          </div>
          <div className="about-texttwo">
            <h2>Notre Vision</h2>
            <p>
            Notre vision est de transformer chaque intérieur en un espace chaleureux, accueillant et raffiné. Nous sommes convaincus que les bons éléments décoratifs peuvent métamorphoser un lieu en un reflet unique de votre style et de votre personnalité. Grâce à nos designs exclusifs, nous aspirons à créer des coussins qui s’intègrent parfaitement à votre mode de vie et à votre esthétique. Que votre style soit minimaliste, éclectique ou luxueux, notre collection vous propose une variété de modèles pour sublimer et enrichir l’ambiance de votre intérieur.
            </p>
            <p>
            Nous croyons que la décoration d’intérieur est bien plus qu’une simple question d’esthétique ; c’est une véritable expression de soi, un moyen de créer un cocon où l’on se sent bien et en harmonie avec son environnement. C’est pourquoi nous nous engageons à concevoir des coussins qui ne sont pas de simples accessoires, mais de véritables éléments de caractère, capables de rehausser l’atmosphère d’un espace et de lui insuffler une âme unique.
            </p>
            <p>
            Chez Cushions By Asma, nous nous efforçons d’apporter une touche d’élégance et d’authenticité à chaque intérieur en proposant des designs qui allient subtilement modernité et tradition. Nos collections sont pensées pour s’adapter à toutes les ambiances, qu’il s’agisse d’un intérieur contemporain aux lignes épurées, d’un salon bohème empreint de chaleur et de douceur, ou encore d’un décor classique où le raffinement est à l’honneur.
            </p>
          </div>
        </div>
      </section>
    </div>
  




    </motion.div>
  );
};

export default About;


